/* Pop-up de proposition Bougie Frenchie (sections/bf-upsell-popup.liquid) :
   quelques secondes après un ajout au panier, propose le produit choisi (sac cadeau). */
(function () {
  var root = document.querySelector('[data-bf-upsell]');
  if (!root) return;
  var variantId = parseInt(root.dataset.variant, 10);
  var delay = (parseFloat(root.dataset.delay) || 0) * 1000;
  var once = root.dataset.once === 'true';
  var design = root.dataset.design === 'true';
  var KEY = 'bfUpsellDeclined-' + variantId;
  var dialog = root.querySelector('.bf-up__dialog');
  var offer = root.querySelector('[data-bf-up-step="offer"]');
  var done = root.querySelector('[data-bf-up-step="done"]');
  var addBtn = root.querySelector('[data-bf-up-add]');
  var errorEl = root.querySelector('[data-bf-up-error]');
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var opened = false, added = false, lastFocus = null, timer = null, busy = false;

  function declined() { try { return once && sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function decline() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    offer.hidden = added; done.hidden = !added;
    root.hidden = false;
    document.documentElement.classList.add('bf-up-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    setTimeout(function () { var f = root.querySelector('[data-bf-up-step]:not([hidden]) button, [data-bf-up-step]:not([hidden]) a'); if (f) f.focus({ preventScroll: true }); }, 60);
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!opened) return;
    opened = false;
    if (!added && !design) decline();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bf-up-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.slice.call(dialog.querySelectorAll('button, a[href]')).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  function maybeShow() {
    if (declined() || opened || busy) return;
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var inCart = cart.items.some(function (i) { return i.variant_id === variantId; });
      if (!inCart) { added = false; open(); }
    }).catch(function () {});
  }

  function onAddResponse(data) {
    if (!data) return;
    var items = data.items || [data];
    var relevant = items.some(function (i) {
      var gift = i.properties && i.properties._cadeau;
      return i.variant_id !== variantId && !gift && i.final_price !== 0;
    });
    if (!relevant) return;
    clearTimeout(timer);
    timer = setTimeout(maybeShow, delay);
  }

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (ADD_RE.test(String(url || ''))) {
        var xhr = this;
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) { try { onAddResponse(JSON.parse(xhr.responseText)); } catch (e) {} }
        });
      }
      return _open.apply(this, arguments);
    };
  }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (ADD_RE.test(url)) p.then(function (res) { if (res.ok) res.clone().json().then(onAddResponse, function () {}); }, function () {});
      return p;
    };
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bf-up-close]')) { close(); return; }
    if (e.target.closest('[data-bf-up-add]') && !busy) {
      busy = true;
      errorEl.hidden = true;
      addBtn.setAttribute('aria-busy', 'true');
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          added = true;
          offer.hidden = true; done.hidden = false;
          var f = done.querySelector('a, button'); if (f) f.focus({ preventScroll: true });
          if (window.theme && theme.miniCart) {
            try { theme.miniCart.updateElements(); } catch (err) {}
            try { theme.miniCart.generateCart(); } catch (err) {}
          }
        })
        .catch(function () { errorEl.hidden = false; })
        .finally(function () { busy = false; addBtn.removeAttribute('aria-busy'); });
    }
  });

  // Éditeur de thème : afficher la pop-up quand la section est sélectionnée
  document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) { added = false; open(); } });
  document.addEventListener('shopify:block:select', function (e) { if (root.contains(e.target)) { added = false; open(); } });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
})();
